// extracted by mini-css-extract-plugin
module.exports = {"main":"Review_main_2_ahR","mobile":"Review_mobile_3g19B","row":"Review_row_1IRFU","name":"Review_name_3GmLC","start":"Review_start_LIn4m","text":"Review_text_2OKTh"};